$('[data-bn="core/list"]').each(function(){
    $(this).find('ul li').each(function(){
        $(this).html('<div>' + $(this).html() + '</div>');
    })
    $(this).find('ol li').each(function(){
        $(this).html('<div>' + $(this).html() + '</div>');
    })
})